const planTypes = [
  {
    id: 'BASIC',
    name: 'Basic',
    description: 'Individual',
    incentives: [
      [
        'Tech',
        [
          'Optimize Listings',
          'Repair Links',
          'Thin Content',
          // 'Optimize Images',
          'Structured Data',
          'Site Verification'
        ]
      ],
      [
        'Content',
        [
          'Pages Content',
          'Blog Content'
        ]
      ]
    ],
    modules: ['TECHNICAL', 'CONTENT', 'CONTENT-PAGE', 'CONTENT-ARTICLE', 'CONTENT-PRODUCT', 'CONTENT-COLLECTION', 'A+'],
    users: 1,
    pages: 50,
    price: 1900,
    monthlyCredits: {
      imageOptimization: 200,
      aiMetaDescription: 100
    }
  },
  {
    id: 'STANDARD',
    name: 'Standard',
    description: 'Small Business',
    incentives: [
      [
        'Tech',
        [
          'Optimize Listings',
          'Repair Links',
          'Thin Content',
          // 'Optimize Images',
          'Structured Data',
          'Site Verification'
        ]
      ],
      [
        'Content',
        [
          'Pages Content',
          'Blog Content'
        ]
      ]
    ],
    modules: ['TECHNICAL', 'CONTENT', 'CONTENT-PAGE', 'CONTENT-ARTICLE', 'CONTENT-PRODUCT', 'CONTENT-COLLECTION', 'A+'],
    users: 3,
    pages: 500,
    price: 3900,
    monthlyCredits: {
      imageOptimization: 1000,
      aiMetaDescription: 500
    }
  },
  {
    id: 'PRO',
    name: 'Pro',
    description: 'Established Business',
    incentives: [
      [
        'Tech',
        [
          'Optimize Listings',
          'Repair Links',
          'Thin Content',
          // 'Optimize Images',
          'Structured Data',
          'Site Verification'
        ]
      ],
      [
        'Content',
        [
          'Pages Content',
          'Blog Content',
          'Collections Content',
          'Products Content'
        ]
      ]
    ],
    modules: ['TECHNICAL', 'CONTENT', 'CONTENT-PAGE', 'CONTENT-ARTICLE', 'CONTENT-PRODUCT', 'CONTENT-COLLECTION', 'A+'],
    users: 5,
    pages: 1000,
    price: 5900,
    monthlyCredits: {
      imageOptimization: 4000,
      aiMetaDescription: 1000
    }
  },
  {
    id: 'PROPLUS',
    name: 'Pro Plus',
    description: 'Large Stores',
    incentives: [
      [
        'Tech',
        [
          'Optimize Listings',
          'Repair Links',
          'Thin Content',
          // 'Optimize Images',
          'Structured Data',
          'Site Verification'
        ]
      ],
      [
        'Content',
        [
          'Pages Content',
          'Blog Content',
          'Collections Content',
          'Products Content'
        ]
      ]
    ],
    modules: ['TECHNICAL', 'CONTENT', 'CONTENT-PAGE', 'CONTENT-ARTICLE', 'CONTENT-PRODUCT', 'CONTENT-COLLECTION', 'A+'],
    users: 5,
    pages: 5000,
    price: 9900,
    monthlyCredits: {
      imageOptimization: 10000,
      aiMetaDescription: 5000
    }
  },
  {
    id: 'ENTERPRISE',
    name: 'Enterprise',
    users: 100,
    pages: 100000000,
    price: 0,
    description: 'Enterprise',
    modules: ['TECHNICAL', 'CONTENT', 'CONTENT-PAGE', 'CONTENT-ARTICLE', 'CONTENT-PRODUCT', 'CONTENT-COLLECTION', 'A+'],
    hidden: true
  }
]

module.exports = planTypes
